/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import kitsu from '@plugins/kitsu';
import { queryString } from '@utils/format';
let $ajax;

export const state = {
  tipe: null,
};

export const mutations = {
  SET_TIPE(state, newValue) {
    state.tipe = newValue;
  },
};

export const actions = {
  async fetch({ rootState, commit }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL + `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/esai`,
    });

    commit('SET_TIPE', payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli');
    return await $ajax.get('/', { params: payload.params });
  },

  async getStatistik({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL +
        `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/esai/statistik`,
    });
    return await $ajax.get('/', { params: payload.params });
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL + `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/esai`,
    });
    return await $ajax.get(`/${payload.id}`);
  },

  downloadList({ rootState, state }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${state.tipe}/esai/download?${queryString(payload.params)}`;
    return Promise.resolve(url);
  },

  action({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/esai/${payload.id}/${
      payload.type
    }`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  async getKinerja({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL +
        `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/${payload.tipe}/kinerja`,
    });
    return await $ajax.get('/', { params: payload.params });
  },

  async getAsesor({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL +
        `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/esai/asesors`,
    });
    return await $ajax.get('/');
  },

  unduhKinerja({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/${
      payload.tipe
    }/${payload.laporan}`;
    return Promise.resolve(url);
  },

  cetakEsai({ rootState, state }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${state.tipe}/esai/${payload.id}/print`;
    return Promise.resolve(url);
  },
};
